module.exports = __webpack_public_path__ + "static/media/road2.44a1aeae.png";